import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DownloadPage() {
  const navigate = useNavigate();

  const platforms = [
    {
      name: 'PWA 网页应用',
      icon: '🌐',
      desc: '直接安装到手机桌面，无需下载商店',
      steps: ['Android: Chrome菜单 → 添加到主屏幕', 'iPhone: Safari分享 → 添加到主屏幕'],
      action: '立即安装',
      url: '/',
      available: true,
    },
    {
      name: 'Android APK',
      icon: '🤖',
      desc: '原生 Android 应用，独立运行更流畅',
      steps: ['下载 APK 文件 → 允许安装未知来源应用 → 点击安装'],
      action: '下载 APK',
      url: process.env.PUBLIC_URL ? null : null,
      available: true,
      url: '/apk/GlobalHeart.apk',
    },
    {
      name: 'iOS App',
      icon: '🍎',
      desc: 'iPhone / iPad 原生应用',
      steps: ['需要 Mac + Xcode 构建，上架 App Store'],
      action: '',
      url: null,
      available: false,
      note: '开发中',
    },
    {
      name: '鸿蒙 App',
      icon: '🔰',
      desc: 'HarmonyOS 原生应用',
      steps: ['需要 DevEco Studio 构建'],
      action: '',
      url: null,
      available: false,
      note: '开发中',
    },
  ];

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>📲 下载 Global Heart</h2>
        <p className="subtitle">选择适合你的方式，随时随地连接世界</p>
      </div>

      <div className="download-grid">
        {platforms.map((p, i) => (
          <div key={i} className={`download-card ${p.available ? '' : 'coming-soon'}`}>
            <div className="download-icon">{p.icon}</div>
            <div className="download-name">{p.name}</div>
            <div className="download-desc">{p.desc}</div>
            <div className="download-steps">
              {p.steps.map((s, j) => <div key={j} className="download-step">{j+1}. {s}</div>)}
            </div>
            {p.available ? (
              <button className="btn btn-primary btn-block" onClick={() => p.url?.endsWith('.apk') ? (window.location.href = p.url) : navigate(p.url)}>
                {p.action}
              </button>
            ) : (
              <div className="download-badge">{p.note}</div>
            )}
          </div>
        ))}
      </div>

      <div className="download-footer">
        <h3>💡 推荐：先用 PWA</h3>
        <p>
          在手机浏览器打开 <strong>http://8.211.150.250</strong>，点「添加到主屏幕」，
          效果和原生 App 一样，马上就能用。
        </p>
        <button className="btn btn-primary" onClick={() => navigate('/')}>
          🌍 开始使用
        </button>
      </div>
    </div>
  );
}
